module.exports = __webpack_public_path__ + "img/phone.8c2aa49d.svg";